export default {
  ev: 'init',
  data: {
    ev: 'init',
    data: {
      apiKey: '5d5d62276301323e6d021325',
      device: 'mobile',
      user: {
        email: 'teste@parcelex.com.br',
        phone: '21992604371',
        cpf: '96154110006',
        name: 'Lucas Marcolino',
      },
      order: {
        shipping: {
          value: 20.2,
          zipCode: '22222222',
          street: 'Rua Teste',
          number: 'n123',
          complement: 'ap 321',
          city: 'Rio de Janeiro',
          state: 'RJ',
        },
        products: [
          {
            id: '1',
            name: 'Smartphone Samsung Galaxy A30s 64GB Dual Chip Android 9.0 Tela 6.4 Octa-Core 4G Câmera Tripla 25MP + 5MP + 8MP - Preto',
            image: 'https://i.zst.com.br/thumbs/49/18/37/972579129.jpg',
            url: 'https://www.zoom.com.br/lead?oid=177663963&sortorder=-1&index=&searchterm=&pagesize=&channel=',
            category: 'Celular e Smartphone',
            categoryId: '7',
            amount: 2,
            value: 230,
          },
          {
            id: '2',
            name: 'Smartphone Samsung Galaxy A30s 64GB Dual Chip Android 9.0 Tela 6.4 Octa-Core 4G Câmera Tripla 25MP + 5MP + 8MP - Preto',
            image: 'https://i.zst.com.br/thumbs/49/18/37/972579129.jpg',
            url: 'https://www.zoom.com.br/lead?oid=177663963&sortorder=-1&index=&searchterm=&pagesize=&channel=',
            category: 'Celular e Smartphone',
            categoryId: '7',
            amount: 1,
            value: 100,
          },
        ],
      },
    },
  },
};
